import React, { FC, Fragment } from 'react';
import { InputAdornment, TableCell, TableRow } from '@mui/material';
import { PriceListAction } from 'models/action';
import { formatCurrency, formatDate } from 'utils/format';
import MonetaryValueInput from 'components/monetary-value/monetary-value.component';

type ActionItemProps = {
    action: PriceListAction;
    onDiscountedPriceChange: (actionDiscountedPrice: { id?: string; discountedPrice: string }) => void;
    onCustomerSpecificTiotandvardPriceChange: (actionTiotandvardPrice: {
        id?: string;
        customerSpecificTiotandvardPrice: string;
    }) => void;
    currency: string;
    isTioTandvardPricingForLabEnabled: boolean;
};

const ActionItem: FC<ActionItemProps> = ({
    action,
    onDiscountedPriceChange,
    onCustomerSpecificTiotandvardPriceChange,
    currency,
    isTioTandvardPricingForLabEnabled,
}: ActionItemProps) => {
    const handleDiscountedPriceChange = (discountedPrice: string) => {
        onDiscountedPriceChange({ id: action._id, discountedPrice: discountedPrice });
    };

    const handleCustomerSpecificTiotandvardPriceChange = (customerSpecificTiotandvardPrice: string) => {
        onCustomerSpecificTiotandvardPriceChange({
            id: action._id,
            customerSpecificTiotandvardPrice: customerSpecificTiotandvardPrice,
        });
    };

    return (
        <Fragment>
            {!action.inactive ? (
                <TableRow hover sx={{ cursor: 'pointer' }}>
                    <TableCell>{action.actionCode}</TableCell>
                    <TableCell>{action.description}</TableCell>
                    <TableCell>{action.category}</TableCell>
                    <TableCell>
                        {action.addedDate ? formatDate(new Date(parseInt(action.addedDate)), 'date') : '-'}
                    </TableCell>
                    <TableCell>{formatCurrency(parseFloat(action.basePrice || '0'), currency)}</TableCell>
                    {isTioTandvardPricingForLabEnabled && (
                        <TableCell>{formatCurrency(parseFloat(action.tiotandvardPrice || '0'), currency)}</TableCell>
                    )}
                    {isTioTandvardPricingForLabEnabled && (
                        <TableCell align="right">
                            <MonetaryValueInput
                                value={action.customerSpecificTiotandvardPrice}
                                allowEmpty={true}
                                onValueChange={handleCustomerSpecificTiotandvardPriceChange}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">{currency}</InputAdornment>,
                                }}
                            />
                        </TableCell>
                    )}
                    <TableCell align="right">
                        <MonetaryValueInput
                            value={action.discountedPrice}
                            allowEmpty={true}
                            onValueChange={handleDiscountedPriceChange}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">{currency}</InputAdornment>,
                            }}
                        />
                    </TableCell>
                </TableRow>
            ) : undefined}
        </Fragment>
    );
};

export default ActionItem;
